import SessionsFilled from "@mui/icons-material/RecentActors";
import SessionsIcon from "@mui/icons-material/RecentActorsOutlined";
import { ReactElement } from "react";
import { RouteObject } from "react-router-dom";

import Layout, {
  useBackToSubaccountListItem,
} from "~frontend/components/Layout";
import Redirect from "~frontend/components/Redirect";
import ProfileIcon from "~frontend/components/icons/Profile";
import ProfileFilled from "~frontend/components/icons/ProfileFilled";
import SubaccountsIcon from "~frontend/components/icons/Subaccounts";
import SubaccountsFilled from "~frontend/components/icons/SubaccountsFilled";
import CacheClearingApolloProvider from "~frontend/providers/CacheClearingApolloProvider";
import { useIntl } from "~frontend/providers/IntlProvider";
import { useTenant } from "~frontend/providers/LoggedInUserProvider";

import { Profile } from "./profile";
import { Sessions } from "./sessions";
import { Subaccounts } from "./subaccounts";

export function UserLayout(): ReactElement {
  const tenant = useTenant()!;
  const intl = useIntl();

  return (
    <CacheClearingApolloProvider>
      <Layout
        topBarTitle={intl.formatMessage({
          defaultMessage: "User Settings",
          description: "Title for the User Settings area of the app",
        })}
        topBarLink="/user/profile"
        sidebarItems={[
          {
            label: intl.formatMessage({
              defaultMessage: "Profile",
              description: "Navigation label for the Profile page",
            }),
            path: "/user/profile",
            icon: <ProfileIcon />,
            activeIcon: <ProfileFilled />,
          },
          ...(tenant.subaccountsEnabled
            ? [
                {
                  label: intl.formatMessage({
                    defaultMessage: "My Subaccounts",
                    description: "Navigation label for the Subaccounts page",
                  }),
                  path: "/user/subaccounts",
                  icon: <SubaccountsIcon />,
                  activeIcon: <SubaccountsFilled />,
                },
              ]
            : []),
          {
            label: intl.formatMessage({
              defaultMessage: "Active Sessions",
              description: "Navigation label for the Sessions page",
            }),
            path: "/user/sessions",
            icon: <SessionsIcon />,
            activeIcon: <SessionsFilled />,
          },
        ]}
        sidebarSecondaryItems={useBackToSubaccountListItem()}
      />
    </CacheClearingApolloProvider>
  );
}

export const userRoutes: RouteObject[] = [
  {
    index: true,
    element: <Redirect to="/user/profile" />,
  },
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "subaccounts",
    element: <Subaccounts />,
  },
  {
    path: "sessions",
    element: <Sessions />,
  },
];
